
import linq from "linq";
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "transfer",
  components: {
    
  }
})
export default class DynamicForm extends Vue {
  @Prop({ default: () => ({}) })  data!: Array<any>;; //数据
  @Prop({ default: () => ({}) })  targetKeys!: Array<any>; ;
  @Prop({  default: false })  filterable!: Boolean;
  @Prop({ default: () => ({}) })  listStyle!: {width: '250px',height: '300px'};
  @Prop({ default: () => [] })  operations!: ['To left','To right'];
  @Prop({ default: () => [] })  titles!: ['源列表', '目的列表'];
  //#region =================================Object中内容如下=========================================
  //#endregion

 getMockData () {
  let mockData:any = [];
  for (let i = 1; i <= 20; i++) {
      mockData.push({
          key: i.toString(),
          label: 'Content ' + i,
          description: 'The desc of content  ' + i,
          disabled: Math.random() * 3 < 1
      });
  }
  return mockData;
  }
  getTargetKeys () {
    return this.getMockData()
               .filter(() => Math.random() * 2 > 1)
               .map(item => item.key);
  }
  render (item) {
      return item.label;
  }
  handleChange (newTargetKeys, direction, moveKeys) {
      console.log(newTargetKeys);
      console.log(direction);
      console.log(moveKeys);
      this.targetKeys = newTargetKeys;
  }
  filterMethod (data, query) {
      return data.label.indexOf(query) > -1;
  }
  reloadMockData () {
      this.data = this.getMockData();
      this.targetKeys = this.getTargetKeys();
  }
  mounted() {
   
  }
}
